import React, { useContext, memo, useRef } from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/styles";
import { SIZE } from "@metacrm/metacrm-material-ui/dist/Button";
import DatePicker from "@metacrm/metacrm-material-ui/dist/DatePicker";
import { useIntl } from "react-intl";

const DateArea = ({ sx, context, children, ...otherProps }) => {
  const { dateRange, setDateRange } = useContext(context);
  const { formatMessage } = useIntl();

  const theme = useTheme();
  const datePickerRef = useRef(null);

  return (
    <Box
      sx={{
        background: theme.customColors.white,
        borderRadius: "4px 4px 0 0",
        padding: "8px",
        marginTop: "8px",
        display: "flex",
        ...sx,
      }}
    >
      {children}
      <Box ml="auto" width="280px">
        <DatePicker
          ref={datePickerRef}
          setDateRange={setDateRange}
          dateRange={dateRange}
          inputProps={{ size: SIZE.MEDIUM }}
          quickSelectOptions={[
            { days: 1, label: formatMessage({ id: "datePicker.range.day" }) },
            { days: 7, label: formatMessage({ id: "datePicker.range.week" }) },
            {
              days: 30,
              label: formatMessage({ id: "datePicker.range.month" }),
            },
            {
              days: "all",
              label: formatMessage({ id: "datePicker.range.all" }),
            },
            {
              days: "custom",
              label: formatMessage({ id: "datePicker.range.custom" }),
            },
          ]}
          {...otherProps}
        />
      </Box>
    </Box>
  );
};

export default memo(DateArea);
